import { render } from "./CalendarEvents.vue?vue&type=template&id=387da318&scoped=true"
import script from "./CalendarEvents.vue?vue&type=script&lang=js"
export * from "./CalendarEvents.vue?vue&type=script&lang=js"

import "./CalendarEvents.vue?vue&type=style&index=0&id=387da318&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387da318"]])

export default __exports__